import React from 'react';
import { useIntl, MessageDescriptor } from '@edx/frontend-platform/i18n';
import { Link } from 'react-router-dom';

import { useHeaderFooter } from '../../hooks';

import './index.scss';

import heroImg from '../../img/contact/CONTACTUS-LWC.jpg';

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
  </svg>
);

const ErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
  </svg>
);

export interface StatusPageAction {
  to: string;
  label: MessageDescriptor;
  variant?: 'primary' | 'secondary';
}

export interface StatusPageMessages {
  pageTitle: MessageDescriptor;
  heroTitle: MessageDescriptor;
  mainMessage: MessageDescriptor;
  additionalInfo: MessageDescriptor;
  bgAlt: MessageDescriptor;
}

export interface StatusPageProps {
  children: React.ReactNode;
  variant: 'success' | 'error';
  pageName: string;
  messages: StatusPageMessages;
  actions: StatusPageAction[];
}

const StatusPage = ({
  children, variant, pageName, messages, actions,
}: StatusPageProps) => {
  const { headerContent, footerContent } = useHeaderFooter(children);
  const intl = useIntl();

  const Icon = variant === 'success' ? CheckIcon : ErrorIcon;

  return (
    <>
      <input type="hidden" id="anPageName" name="page" defaultValue={pageName} />
      <div className="container-center-horizontal">
        <div className={`about screen contact status-page status-page--${variant}`}>
          <div className="homepage">
            {headerContent}
            <div className="overlap-group6">
              <div className="hero-image">
                <div className="overlap-group-1">
                  <div
                    className="overlap-group-item"
                    style={{ backgroundImage: `url("${heroImg}")` }}
                    role="img"
                    aria-label={intl.formatMessage(messages.bgAlt)}
                  />
                  <h1 className="about-us recklessneue-regular-normal-white-100-1px">
                    <span className="recklessneue-regular-normal-white-100-1px">
                      {intl.formatMessage(messages.heroTitle)}
                    </span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="legatum-container the-course">
            <div className="status-content">
              <div className="status-icon">
                <Icon />
              </div>
              <h2 className="status-title">
                {intl.formatMessage(messages.pageTitle)}
              </h2>
              <p className="status-message">
                {intl.formatMessage(messages.mainMessage)}
              </p>
              <p className="status-info">
                {intl.formatMessage(messages.additionalInfo)}
              </p>
              <div className="action-buttons">
                {actions.map((action) => (
                  <Link
                    key={action.to}
                    to={action.to}
                    className={action.variant === 'secondary' ? 'return-home-btn' : 'primary-btn'}
                  >
                    {intl.formatMessage(action.label)}
                  </Link>
                ))}
              </div>
            </div>
          </div>
          {footerContent}
        </div>
      </div>
    </>
  );
};

export default StatusPage;
